export default {
  cashTable: {
    year: '',
    jan: 'T1',
    feb: 'T2',
    mar: 'T3',
    apr: 'T4',
    may: 'T5',
    jun: 'T6',
    jul: 'T7',
    aug: 'T8',
    sep: 'T9',
    oct: 'T10',
    nov: 'T11',
    dec: 'T12',
    total: 'TỔNG',
    yield: 'YIELD',
  },
  listTab: {
    divHis: 'Thống kê và Dự báo Cổ tức',
  },
  disclaimerContent: `Nhà đầu tư cần lưu ý rằng các số liệu chính thức được công bố bởi doanh nghiệp.
  FiinGroup không đảm bảo tính chính xác của các kết quả dự phóng. Do đó, các kết quả này chỉ được sử dụng cho mục đích tham khảo.
  Vì vậy, FiinGroup không chịu trách nhiệm cho bất cứ tổn thất nào của nhà đầu tư`,
  disclaimer: `*Miễn trừ trách nhiệm: `,
  titleLeftPE: 'P/E',
  titleRightPE: 'Tỷ lệ cổ tức(%)',
  titleLeftDE: 'Lợi Nhuận và Cổ Tức (VND)',
  titleRightDE: 'Hệ số Thanh Toán Cổ Tức(%)',
  titlePE: 'BIỂU ĐỒ P/E VÀ TỶ LỆ CỔ TỨC',
  priceEarnings: 'P/E',
  dyLegend: 'Tỷ Lệ Cổ Tức',
  dy: 'Tỷ lệ Cổ Tức: ',
  pe: 'P/E: ',
  dyPercent: 'Tỷ lệ Cổ Tức:  {0}%',
  titleDE: 'LỢI NHUẬN VÀ CỔ TỨC',
  EPS: 'EPS',
  DPS: 'DPS',
  dividendPayout: 'Hệ số Thanh Toán Cổ Tức',
  EPSTooltip: 'EPS: ',
  DPSTooltip: 'DPS: ',
  dividendPayoutTooltip: 'Hệ số thanh toán cổ tức: ',
  estimatedNumber: 'Kế hoạch trả cổ tức theo nghị quyết ĐHCĐ',
  expectedNumber: 'FiinTrade dự báo',
  cellTooltip: 'Trả %{value} cho %{year}',
};
